export default [ 
    {
        label: "Ethereum", value : 1, logo: "https://chainlist.org/_next/image?url=https%3A%2F%2Fdefillama.com%2Fchain-icons%2Frsz_ethereum.jpg&w=32&q=75"
    }, 
    {
       label: "Binance Smart Chain", value: 56, logo: "https://chainlist.org/_next/image?url=https%3A%2F%2Fdefillama.com%2Fchain-icons%2Frsz_binance.jpg&w=32&q=75"
    },
    {
        label: "Binance Smart Chain", value: 97, logo: "https://chainlist.org/_next/image?url=https%3A%2F%2Fdefillama.com%2Fchain-icons%2Frsz_binance.jpg&w=32&q=75"
    },
    {
        label: "Goerli", value : 5, logo: "https://chainlist.org/_next/image?url=https%3A%2F%2Fdefillama.com%2Fchain-icons%2Frsz_ethereum.jpg&w=32&q=75"
    }
]